import locale77427e78 from '../../i18n/en.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: false,
}
export const options = {
  vueI18n: {"fallbackLocale":"en"},
  vueI18nLoader: false,
  locales: [{"name":"Português - Brasil","code":"pt-br","iso":"pt-BR","file":"pt-br.js"},{"name":"English","code":"en","iso":"en","file":"en.js"},{"name":"Español","code":"es","iso":"es","file":"es.js"},{"name":"Español - España","code":"es-es","iso":"es-ES","file":"es-es.js"},{"name":"Español - Colombia","code":"es-co","iso":"es-CO","file":"es-co.js"},{"name":"Español - México","code":"es-mx","iso":"es-MX","file":"es-mx.js"},{"name":"Français","code":"fr","iso":"fr","file":"fr.js"},{"name":"日本語","code":"ja","iso":"ja","file":"jp.js"},{"name":"Italiano","code":"it","iso":"it","file":"it.js"}],
  defaultLocale: "pt-br",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "i18n/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":true,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":".hotmart.com","cookieKey":"hmLangCookie","cookieSecure":false,"fallbackLocale":"en","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://hotmart.com",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"index":{"pt-br":"/","en":"/","es":"/","es-mx":"/","es-co":"/","es-es":"/","fr":"/","ja":"/","it":"/"},"about":{"pt-br":"/sobre-nos","en":"/about","es":"/sobre","es-mx":"/sobre","es-co":"/sobre","es-es":"/sobre","fr":"/propos-de-nous","ja":"/%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6","it":"/chi-siamo"},"affiliates":{"pt-br":"/afiliados","en":"/affiliates","es":"/afiliados","es-mx":"/afiliados","es-co":"/afiliados","es-es":"/afiliados","fr":"/affilies","ja":"/%E3%82%A2%E3%83%95%E3%82%A3%E3%83%AA%E3%82%A8%E3%82%A4%E3%82%BF%E3%83%BC","it":"/affiliazione"},"members-area/index":{"pt-br":"/area-de-membros","en":"/members-area","es":"/area-de-miembros","es-mx":false,"es-es":false,"es-co":false,"fr":"/zone-des-membres","ja":false,"it":false},"members-area/thank-you":{"pt-br":"/area-de-membros/obrigado","en":"/members-area/thank-you","es":"/area-de-miembros/gracias","es-mx":false,"es-es":false,"es-co":false,"fr":false,"ja":false,"it":false},"payments":{"pt-br":"/pagamentos","en":"/payments","es":"/pagos","es-co":"/pagos","es-mx":false,"es-es":"/pagos","fr":"/paiements","ja":false,"it":false},"pricing":{"en":"/pricing","es-es":"/precios","fr":"/prix","pt-br":false,"es":false,"es-mx":false,"es-co":false,"ja":false,"it":false},"producers":{"pt-br":"/produtores","en":"/pricing","es":"/productores","es-co":"/productores","es-mx":"/productores","es-es":"/productores","fr":"/producteurs","ja":false,"it":false},"solutions":{"pt-br":"/solucoes","en":"/solutions","es":"/soluciones","es-mx":"/soluciones","es-co":"/soluciones","es-es":"/soluciones","fr":"/solutions","ja":"/%E3%82%BD%E3%83%AA%E3%83%A5%E3%83%BC%E3%82%B7%E3%83%A7%E3%83%B3","it":"/funzionalita"},"hotmart-app":{"pt-br":"/app-da-hotmart","en":"/hotmart-app","es":"/app-de-hotmart","es-mx":"/app-de-hotmart","es-co":"/app-de-hotmart","es-es":"/app-de-hotmart","fr":false,"ja":false,"it":false},"tour/index":{"pt-br":"/tour","en":"/tour","es":"/tour","es-mx":"/tour","es-co":"/tour","es-es":"/tour","fr":"/tour","ja":false,"it":false},"tour/_id":{"pt-br":"/tour/:id","en":"/tour/:id","es":"/tour/:id","es-mx":"/tour/:id","es-co":"/tour/:id","es-es":"/tour/:id","fr":"/tour/:id","ja":false,"it":false},"sitemap":{"pt-br":"/mapa-do-site","en":false,"es":false,"es-mx":false,"es-co":false,"es-es":false,"fr":false,"ja":false,"it":false},"is-hotmart-for-me":{"pt-br":false,"en":"/is-hotmart-for-me","es":false,"es-mx":false,"es-co":false,"es-es":false,"fr":false,"ja":false,"it":false},"sales-accelerator":{"pt-br":"/acelerador-de-vendas","en":false,"es":false,"es-mx":false,"es-co":false,"es-es":false,"fr":false,"ja":false,"it":false},"members-area/paid-media":{"pt-br":"/area-de-membros/midias-pagas","en":false,"es":false,"es-mx":false,"es-es":false,"es-co":false,"fr":false,"ja":false,"it":false},"lp-producer":{"pt-br":"/produtor-interessado","en":false,"es":false,"es-mx":false,"es-co":false,"es-es":false,"fr":false,"ja":false,"it":false}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"name":"Português - Brasil","code":"pt-br","iso":"pt-BR","file":"pt-br.js"},{"name":"English","code":"en","iso":"en","file":"en.js"},{"name":"Español","code":"es","iso":"es","file":"es.js"},{"name":"Español - España","code":"es-es","iso":"es-ES","file":"es-es.js"},{"name":"Español - Colombia","code":"es-co","iso":"es-CO","file":"es-co.js"},{"name":"Español - México","code":"es-mx","iso":"es-MX","file":"es-mx.js"},{"name":"Français","code":"fr","iso":"fr","file":"fr.js"},{"name":"日本語","code":"ja","iso":"ja","file":"jp.js"},{"name":"Italiano","code":"it","iso":"it","file":"it.js"}],
  localeCodes: ["pt-br","en","es","es-es","es-co","es-mx","fr","ja","it"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "p",
  3: "t",
  4: "-",
  5: "b",
  6: "r",
  7: ".",
  8: "j",
  9: "s",
  10: "\"",
  11: ":",
  12: "\"",
  13: ".",
  14: ".",
  15: "/",
  16: "i",
  17: "1",
  18: "8",
  19: "n",
  20: "/",
  21: "p",
  22: "t",
  23: "-",
  24: "b",
  25: "r",
  26: ".",
  27: "j",
  28: "s",
  29: "\"",
  30: ",",
  31: "\"",
  32: "e",
  33: "n",
  34: ".",
  35: "j",
  36: "s",
  37: "\"",
  38: ":",
  39: "\"",
  40: ".",
  41: ".",
  42: "/",
  43: "i",
  44: "1",
  45: "8",
  46: "n",
  47: "/",
  48: "e",
  49: "n",
  50: ".",
  51: "j",
  52: "s",
  53: "\"",
  54: ",",
  55: "\"",
  56: "e",
  57: "s",
  58: ".",
  59: "j",
  60: "s",
  61: "\"",
  62: ":",
  63: "\"",
  64: ".",
  65: ".",
  66: "/",
  67: "i",
  68: "1",
  69: "8",
  70: "n",
  71: "/",
  72: "e",
  73: "s",
  74: ".",
  75: "j",
  76: "s",
  77: "\"",
  78: ",",
  79: "\"",
  80: "e",
  81: "s",
  82: "-",
  83: "e",
  84: "s",
  85: ".",
  86: "j",
  87: "s",
  88: "\"",
  89: ":",
  90: "\"",
  91: ".",
  92: ".",
  93: "/",
  94: "i",
  95: "1",
  96: "8",
  97: "n",
  98: "/",
  99: "e",
  100: "s",
  101: "-",
  102: "e",
  103: "s",
  104: ".",
  105: "j",
  106: "s",
  107: "\"",
  108: ",",
  109: "\"",
  110: "e",
  111: "s",
  112: "-",
  113: "c",
  114: "o",
  115: ".",
  116: "j",
  117: "s",
  118: "\"",
  119: ":",
  120: "\"",
  121: ".",
  122: ".",
  123: "/",
  124: "i",
  125: "1",
  126: "8",
  127: "n",
  128: "/",
  129: "e",
  130: "s",
  131: "-",
  132: "c",
  133: "o",
  134: ".",
  135: "j",
  136: "s",
  137: "\"",
  138: ",",
  139: "\"",
  140: "e",
  141: "s",
  142: "-",
  143: "m",
  144: "x",
  145: ".",
  146: "j",
  147: "s",
  148: "\"",
  149: ":",
  150: "\"",
  151: ".",
  152: ".",
  153: "/",
  154: "i",
  155: "1",
  156: "8",
  157: "n",
  158: "/",
  159: "e",
  160: "s",
  161: "-",
  162: "m",
  163: "x",
  164: ".",
  165: "j",
  166: "s",
  167: "\"",
  168: ",",
  169: "\"",
  170: "f",
  171: "r",
  172: ".",
  173: "j",
  174: "s",
  175: "\"",
  176: ":",
  177: "\"",
  178: ".",
  179: ".",
  180: "/",
  181: "i",
  182: "1",
  183: "8",
  184: "n",
  185: "/",
  186: "f",
  187: "r",
  188: ".",
  189: "j",
  190: "s",
  191: "\"",
  192: ",",
  193: "\"",
  194: "j",
  195: "p",
  196: ".",
  197: "j",
  198: "s",
  199: "\"",
  200: ":",
  201: "\"",
  202: ".",
  203: ".",
  204: "/",
  205: "i",
  206: "1",
  207: "8",
  208: "n",
  209: "/",
  210: "j",
  211: "p",
  212: ".",
  213: "j",
  214: "s",
  215: "\"",
  216: ",",
  217: "\"",
  218: "i",
  219: "t",
  220: ".",
  221: "j",
  222: "s",
  223: "\"",
  224: ":",
  225: "\"",
  226: ".",
  227: ".",
  228: "/",
  229: "i",
  230: "1",
  231: "8",
  232: "n",
  233: "/",
  234: "i",
  235: "t",
  236: ".",
  237: "j",
  238: "s",
  239: "\"",
  240: "}",
}

export const localeMessages = {
  'en.js': () => Promise.resolve(locale77427e78),
  'pt-br.js': () => import('../../i18n/pt-br.js' /* webpackChunkName: "lang-pt-br.js" */),
  'es.js': () => import('../../i18n/es.js' /* webpackChunkName: "lang-es.js" */),
  'es-es.js': () => import('../../i18n/es-es.js' /* webpackChunkName: "lang-es-es.js" */),
  'es-co.js': () => import('../../i18n/es-co.js' /* webpackChunkName: "lang-es-co.js" */),
  'es-mx.js': () => import('../../i18n/es-mx.js' /* webpackChunkName: "lang-es-mx.js" */),
  'fr.js': () => import('../../i18n/fr.js' /* webpackChunkName: "lang-fr.js" */),
  'jp.js': () => import('../../i18n/jp.js' /* webpackChunkName: "lang-jp.js" */),
  'it.js': () => import('../../i18n/it.js' /* webpackChunkName: "lang-it.js" */),
}
